import { useTranslation } from "react-i18next";

import type { TokenDefinition } from "../tokens/types";
import { TokenCollector } from "./collectors/TokenCollector";

export interface CollectorPanelProps {
  definition: TokenDefinition;
  initialValues?: Record<string, string>;
  onSubmit: (params: Record<string, string>) => void;
  onClose: () => void;
  /** Insert flow vs. editing an existing token — only changes the header caption. */
  editing?: boolean;
}

/**
 * The inner body of the collector popover: a header (token label + caption) over the generic
 * {@link TokenCollector}. Shared by the palette/drop popover ({@link TokenCollectorPopover}) and the
 * edit-in-place popover on the rich chip, so both look identical regardless of how they're anchored.
 */
export const CollectorPanel = ({ definition, initialValues, onSubmit, onClose, editing }: CollectorPanelProps) => {
  const { t } = useTranslation("templates");
  return (
    <div className="flex flex-col">
      <div className="border-b px-4 py-3">
        <h3 className="text-sm font-semibold leading-none">{definition.getLabel()}</h3>
        <p className="mt-1 text-xs text-muted-foreground">
          {editing ? t("Edit this field") : t("Configure and insert this field")}
        </p>
      </div>
      <div className="px-4 py-3">
        <TokenCollector definition={definition} initialValues={initialValues} onSubmit={onSubmit} onCancel={onClose} />
      </div>
    </div>
  );
};
